<script setup>
import { useI18n } from 'vue-i18n';
import ReleaseBadge from './ReleaseBadge.vue';
import messages from './en.json';
import developerLogo from './assets/logo-alvaix.jpeg';

defineProps({
  compact: { type: Boolean, default: false },
  sidebar: { type: Boolean, default: false },
});

const { t } = useI18n({
  useScope: 'local',
  messages: { en: messages },
  fallbackLocale: 'en',
});
const DEVELOPER_NAME = 'ALVAIX';
</script>

<template>
  <footer
    class="shrink-0 px-3 py-4 text-center text-xs leading-5 text-n-slate-11"
    :aria-label="t('DEVELOPED_BY', { developer: DEVELOPER_NAME })"
  >
    <img
      :src="developerLogo"
      :alt="DEVELOPER_NAME"
      width="1600"
      height="900"
      class="mx-auto mb-1 h-auto max-w-full rounded bg-white"
      :class="compact ? 'w-10' : sidebar ? 'w-24' : 'w-40'"
    />
    <span v-if="compact" class="font-semibold tracking-widest">
      {{ DEVELOPER_NAME }}
    </span>
    <span v-else>
      {{ t('DEVELOPED_BY', { developer: DEVELOPER_NAME }) }}
    </span>
    <ReleaseBadge v-if="!compact" class="mt-2" />
  </footer>
</template>
